import React from 'react';
import { CaretDown, CaretRight } from '@wix/wix-ui-icons-common/system';
import Button from '../../../Button';
import TextButton from '../../../TextButton';
import { buttonTypes, dataHooks, skins } from '../../constants';

import { st, classes } from './AccordionItemCaret.st.css';
import { AccordionItemCaretProps } from '../../Accordion.types';

const AccordionItemCaret = ({
  showLabel,
  buttonType,
  skin,
  open,
  disabled,
  hover,
  collapseLabel,
  expandLabel,
}: AccordionItemCaretProps) => {
  const skinProp = skin === skins.neutral ? 'dark' : 'standard';
  const isLabelShown = showLabel === 'always' || hover;
  const label = open ? collapseLabel : expandLabel;

  if (buttonType === buttonTypes.node && isLabelShown && label) {
    return <>{label}</>;
  }
  if (
    buttonType === buttonTypes.button &&
    label &&
    // For this buttonType, showLabel default is 'always' if undefined.
    (showLabel === 'hover' ? hover : true)
  ) {
    return (
      <Button
        skin={skinProp}
        size="small"
        priority={open ? 'secondary' : 'primary'}
        disabled={disabled}
        dataHook={dataHooks.toggleButton}
        children={label}
      />
    );
  }
  if (buttonType === buttonTypes.textButton) {
    const suffixIcon = open ? <CaretDown /> : <CaretRight />;

    return (
      // @ts-ignore
      <TextButton
        className={st(classes.textButton, {
          withLabel: !!(isLabelShown && label),
        })}
        skin={skinProp}
        suffixIcon={suffixIcon}
        disabled={disabled}
        dataHook={dataHooks.toggleButton}
        children={isLabelShown && label}
      />
    );
  }

  return null;
};

export default AccordionItemCaret;
